editButtonController.$inject = ['$scope', '$uibModalInstance', '$translate', 'QuickRepliesFactory', 'button'];
export function editButtonController($scope, $uibModalInstance, $translate, QuickRepliesFactory, button) {
  $scope.submit = submit;
  $scope.cancel = cancel;
  $scope.deleteButton = deleteButton;

  init();

  function submit() {
    QuickRepliesFactory.cleanupButtonPayload($scope.button);
    $uibModalInstance.close({type: 'edit', button: $scope.button});
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function deleteButton() {
    $uibModalInstance.close({type: 'delete'});
  }

  function init() {
    $scope.button = button;
  }

}
